__webpack_require__.p = "https://product-results.dev.core-artifacts.com/static/";